import { APP_VERSION } from './version';

export const APP_CONFIG = {
  name: 'Platform',
  version: APP_VERSION,
  defaultLocale: 'es-AR',
  defaultCurrency: 'ARS',
  pagination: {
    defaultPageSize: 10,
    pageSizeOptions: [10, 20, 50, 100],
  },
  session: {
    tokenKey: 'hb_auth_token',
    refreshTokenKey: 'hb_refresh_token',
    expirationKey: 'hb_token_expiration',
    /** Idle timeout before session warning (15 min, aligned with access TTL) */
    idleTimeoutMs: 900_000,
    /** Countdown shown in the warning modal */
    warningDurationMs: 60_000,
    /** Access token TTL from BFF (`expires_in`) */
    accessTokenTtlSeconds: 900,
    accessTokenRefreshLeewayMs: 120_000,
  },
  validation: {
    password: {
      minLength: 8,
      requireUppercase: true,
      requireLowercase: true,
      requireNumber: true,
      requireSpecialChar: true,
    },
  },
} as const;
